// extracted by mini-css-extract-plugin
export var orderSummary = "_qa-0";
export var showMoreLessButton = "_qa-1";